import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import Widget from './components/Widget';

const Root = ({
    store,
    settings
}) => {
    return (
        <Provider store={store}>
            <Widget {...settings} />
        </Provider>
    );
};

Root.propTypes = {
    store: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./widget/src/js/Root.jsx